import React, { useContext, useEffect, useState } from 'react';
import { ITrainingSet, ITrainingRevision } from '../../types/my-types';
import { AppContext } from '../../App';
import SelectModel from '../extractionBatches/create/SelectModel';
import usePublicTrainingSets from '../hooks/usePublicTrainingSets';
import { ITrainingSetsForDropdown } from '../common/SelectTrainingSet';
export interface SelectPublicTrainingSetProps {
  setTrainingSet: (trainingSet: ITrainingSet | undefined) => void;
  disabled?: boolean;
  currentTrainingSetId?: string;
  inclurrentCurrentTrainingSet?: boolean;
  dataPoolId: string;
}

const SelectPublicTrainingSet: React.FC<SelectPublicTrainingSetProps> = ({
  setTrainingSet,
  disabled,
  currentTrainingSetId,
  inclurrentCurrentTrainingSet = true,
  dataPoolId,
}) => {
  const [search, setSearch] = useState('');

  let items: ITrainingSetsForDropdown[] = [];

  let publicTrainingSets = usePublicTrainingSets(dataPoolId, search);
  let getPagesLength = 0;

  if (publicTrainingSets.length > 0) {
    getPagesLength = publicTrainingSets.length;
  }
  if (publicTrainingSets.length > 0) {
    items = publicTrainingSets?.map((ts: ITrainingSet) => ({
      id: ts.id,
      label: ts.label,
    }));
  }

  // Move same model to the beginning of the list
  const sameModel = items.filter((ts) => ts.id === currentTrainingSetId);
  const allModelsWithoutSameModel = items.filter((ts) => ts.id !== currentTrainingSetId);

  if (inclurrentCurrentTrainingSet) {
    items = [...sameModel, ...allModelsWithoutSameModel];
  } else {
    items = allModelsWithoutSameModel;
  }

  const selectTS = (value?: string) => {
    const selectedTrainSet = publicTrainingSets.find((t: ITrainingSet) => t.id === value);
    setTrainingSet(selectedTrainSet);
  };

  // select prev training set as default for re-extract
  // select classifier for create new extraction batch
  return (
    <SelectModel
      setSearch={setSearch}
      style={{ width: '100%' }}
      items={items}
      onChangeCallback={selectTS}
      disabled={disabled}
      defaultValue={currentTrainingSetId}
      loading={publicTrainingSets.length === 0}
      totalItems={getPagesLength}
    />
  );
};

export default SelectPublicTrainingSet;
